import { render } from "./PremiumLockView.vue?vue&type=template&id=5d363539&scoped=true"
import script from "./PremiumLockView.vue?vue&type=script&lang=js"
export * from "./PremiumLockView.vue?vue&type=script&lang=js"

import "./PremiumLockView.vue?vue&type=style&index=0&id=5d363539&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d363539"]])

export default __exports__